import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { materialModules } from '../../../angular-material.module';
import { SharedModule } from '../../../shared/shared.module';
import { ContentSectionContainerComponent } from './content-section-container/content-section-container.component';
import { ContentSectionListComponent } from './content-section-list/content-section-list.component';
import { ContentSectionComponent } from './content-section/content-section.component';
import { ContentSectionDialogComponent } from './content-section-dialog/content-section-dialog.component';
import { QuillModule } from 'ngx-quill'
import { CreativeUnitPackageListingModule } from '../creative-unit-package-listing/creative-unit-package-listing.module';
import { CreativeUnitPackageCategoryModule } from '../creative-unit-package-category/creative-unit-package-category.module';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		MatDialogModule,
		ReactiveFormsModule,
		SharedModule,
		CreativeUnitPackageListingModule,
		...materialModules,
		QuillModule.forRoot(),
		CreativeUnitPackageCategoryModule
	],
	declarations: [
		ContentSectionContainerComponent,
		ContentSectionListComponent,
		ContentSectionComponent,
 		ContentSectionDialogComponent
	],
	exports: [
		ContentSectionContainerComponent,
		ContentSectionListComponent,
		ContentSectionComponent
	]
})
export class ContentSectionModule {}
